import Image from "next/image";
import about from "../../assets/images/about/About1.jpg";
import overview from "../../assets/images/about/overview.webp";
import gov1 from "../../assets/images/about/gov1.webp";
import gov2 from "../../assets/images/about/gov2.webp";
import gov3 from "../../assets/images/about/gov3.webp";
import gov4 from "../../assets/images/about/gov4.webp";
import gov5 from "../../assets/images/about/gov5.webp";
import gov6 from "../../assets/images/about/gov6.webp";
import roundarrow from "../../assets/images/home/roundarrow.svg";
import styles from "./about.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import Head from "next/head";

const About = () => {
  const socialresponsibility=[
    {img:gov1,alt:"Governmentof India",title:"Ministry of Social Justice and Empowerment (Government of India)",description:"We have been chosen by the Govt. of India as preferred UPSC & TNPSC Coaching Partner."},
    {img:gov2,alt:"Govt of A.P",title:"YSR Vidyonnathi",title1:"(A Govt of A.P Undertaking)",description:"We have been chosen by the Govt. of Andhra Pradesh as preferred UPSC & TNPSC Coaching Partner."},
    {img:gov3,alt:"Government of Karnataka",title:"Department of Social Welfare",title1:"(Government of Karnataka)",description:"We have been chosen by the Govt. of Karnataka as preferred UPSC & TNPSC Coaching Partner."},
    {img:gov4,alt:"Sigaram Foundation",title:"Sigaram Foundation",description:"We have been chosen by Sigaram foundation as preferred UPSC Coaching Partner."},
    {img:gov5,alt:"Shankar Memorial Educational & Charitable Trust",title:"Shankar Memorial",title1:"Educational & Charitable Trust",description:"To ensure upliftment of deserving candidates among the economically deprived and differently-abled candidates across the country. "},
    {img:gov6,alt:"Government of Kolkata",title:"(Government of Kolkata)",description:"We have been chosen by the Govt. of kolkata as preferred UPSC Coaching Partner."}
  ]

  const pagebottom=[
    {content:"Why Us?",href:"/why-shankar-ias",image:roundarrow,alt:"Why Shankar IAS Academy?"},
    {content:"Infrastructure",href:"/our-infrastructure",image:roundarrow,alt:"Shankar IAS Academy branches"},
    {content:"Faculty Team",href:"/our-faculty",image:roundarrow,alt:"Shankar IAS Academy Faculty Team"}
  ]

  return (
    <>
    <Head>
                <meta charset="UTF-8" />
                 
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>About us | Shankar IAS Academy</title>
                <meta name="title" content="About us | Shankar IAS Academy" />
                <meta name="description" content="Shankar IAS Academy - Pioneering excellence in UPSC Coaching. Learn about our Vision, Mission and unwavering commitment to student success." />
                <link rel="canonical" href="https://www.shankariasacademy.com/about-us/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="About us | Shankar IAS Academy" />
                <meta property="og:description" content="Shankar IAS Academy - Pioneering excellence in UPSC Coaching. Learn about our Vision, Mission and unwavering commitment to student success." />
                <meta property="og:url" content="https://www.shankariasacademy.com/about-us/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>
      <Navbar title="about" />

      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>
              About Shankar IAS Academy
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col pt-2">
            <Image
              src={about}
              className="img-fluid w-100"
              alt="About Shankar IAS Academy"
              title="About Shankar IAS Academy"
            />
          </div>
        </div>
      </div>
      {/*  Overview  */}
      <div className="container">
        <div className="row">
          <div className="col pt-md-4 pt-3">
            <h2 className={`${styles.sectiontitle} mb-0`}>Overview</h2>
          </div>
        </div>

        <div className="row pt-3">
          <div className="col-lg-6 col-12 align-self-center">
            <Image
              src={overview}
              className="img-fluid w-100"
              alt="Shankar IAS Academy Anna Nagar"
              title="About Shankar IAS Academy Anna Nagar"
            />
          </div>
          <div className="col-lg-6 col-12 pt-4">
            <p
              className={`${styles.sectionsubtitle}`}
              id={styles.aboucontentborder}
            >
              Providing the best learning
              <br /> methods since 2004
            </p>
            <p className={`${styles.acheiverrank} pt-2 pt-md-3 pt-lg-4`}>
              <span className={`${styles.acheivername}`}>
                SHANKAR IAS ACADEMY
              </span>
              , one of the best institutions in India for coaching and mentoring
              thousands of Civil Service aspirants was founded in 2004. The
              academy which was nothing but a gleam in the eye of Mr. Shankar D
              in 2004, a Post Graduate in Agriculture (also an aspirant who
              qualified for interview twice), has evolved over the years to the
              extent of successfully helping 2500+ candidates realise their
              dream of becoming a bureaucrat and guiding thousands of others to
              realise their potential. We take pride in having successfully
              contributed to nation building albeit, in a small way.
            </p>
          </div>
        </div>
      </div>

      {/* <!-- Vision and Mission --> */}
      <div className="container">
        <div className="row pt-md-5 pt-3">
          <div className="col-md-6 col-12">
            <div className={`${styles.visionbg} p-5 h-100`}>
              <h2
                className={`${styles.sectiontitle}`}
                id={styles.aboucontentborder}
              >
                Vision
              </h2>
              <p className={`${styles.acheiverrank} pt-2 pt-md-3 pt-lg-4`}>
                To become a renowned institution producing eminent and
                responsible civil servants for the society. To give hope and
                opportunity to aspirants from various social-economic
                backgrounds to realize their dream of becoming civil servants.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-12 pt-3 pt-md-0">
            <div className={`${styles.missionbg} p-5 h-100`}>
              <h2
                className={`${styles.sectiontitle}`}
                id={styles.aboucontentborder}
              >
                Mission
              </h2>
              <p className={`${styles.acheiverrank} pt-2 pt-md-3 pt-lg-4`}>
                To provide meticulous and focused training to the aspirants to
                succeed in the Civil Services examination.
              </p>
              <p className={`${styles.acheiverrank} pt-2`}>
                To create an environment where the students have access to all
                that is required to prepare for the civil services examination
                effectively, efficiently and enthusiastically by ensuring them
                with excellent coaching and finest study materials.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Social Responsibility --> */}
      <div className="container-fluid mt-5" id={styles.greybackground}>
        <div className="row">
          <div className="col py-5 my-md-3">
            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} `} id={styles.aboucontentborder}>
                    Social Responsibility
                  </h2>
                </div>
              </div>

              <div className="row">
                <div className="col px-0">
                  <div className="row pt-4">

                    {socialresponsibility.map((item, index)=>(
                    <div className="col-md-6 col-xl-4 col-12 mb-4" key={index}>
                      <div className={`${styles.aboutbox} p-lg-5 p-4 h-100 text-center`}>
                        <Image
                          src={item.img}
                          className="img-fluid"
                          alt={item.alt}
                          title={item.title}
                        />
                        <div id={styles.governmentname}>
                        <p
                          className={`${styles.acheivername} pt-3 mb-0`}
                          
                        >
                          {item.title}
                        </p>
                        <p
                          className={`${styles.acheivername}`}
                        >
                          {item.title1}
                        </p>
                        </div>
                       
                        <p className={`${styles.acheiverrank}`}>
                          {item.description}
                        </p>
                      </div>
                    </div>
                    ))}

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row pt-5">
          <div className="col px-md-0">
            <div className="row">

              {pagebottom.map((bottom, index)=>(
                <div className="col-md-6 col-xl-4 col-12 mb-3" key={index}>
                <div className={`${styles.aboutbox1} p-lg-5 p-4 h-100`}>
                  <div className="row">
                    <div className="col-lg-7 col-md-8 col-6 align-self-center">
                      <p
                        className={`${styles.sectionsubtitle} mb-0`}
                        id={styles.aboutmedia}
                      >
                        {bottom.content}
                      </p>
                    </div>
                    <div className="col-lg-5 col-md-4 col-6 text-end">
                      <Link href={bottom.href}>
                        <Image
                          src={bottom.image}
                          className={`${styles.img} img-fluid`}
                          alt={bottom.alt}
                          title={bottom.alt}

                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              ))}


            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
